<!-- <mat-sidenav-container>
  <mat-sidenav mode="side" opened class="side-nav">
    <mat-nav-list>
      <section *ngFor="let page of pages">
        <a
          *checkPermissions="page.link"
          mat-list-item
          [routerLink]="page.link"
          [activated]="page.isActive"
          class="side-nav-link"
        >
          <article fxLayoutAlign="start center" fxLayoutGap="7">
            <mat-icon>{{ page.icon }}</mat-icon>
            <span>{{ page.title }}</span>
          </article>
        </a>
      </section>
    </mat-nav-list>
  </mat-sidenav>
  <mat-sidenav-content style="height: 92vh"
    ><ng-content></ng-content
  ></mat-sidenav-content>
</mat-sidenav-container> -->

<mat-sidenav-container>
  <mat-sidenav mode="side" opened class="side-nav">
    <section class="sidebar-content-wrapper">
      <mat-nav-list>
        <section *ngFor="let page of pages">
          <a
            *checkPermissions="page.link"
            disableRipple
            mat-list-item
            [routerLink]="page.link"
            [activated]="page.isActive"
            class="side-nav-link"
          >
            <article fxLayoutAlign="start center" fxLayoutGap="7">
              <mat-icon color="primary">{{ page.icon }}</mat-icon>
              <span
                class="accent-text"
                [ngClass]="{ 'font-bold': isActive(page.link) }"
              >
                {{ page.title }}
              </span>
            </article>
          </a>
        </section>
      </mat-nav-list>
    </section>
  </mat-sidenav>
  <mat-sidenav-content class="main-content-wrapper">
    <ng-content></ng-content>
  </mat-sidenav-content>
</mat-sidenav-container>
